// extracted by mini-css-extract-plugin
export default {"calendar":"_1SKma","mobile":"_26_Fy"};